























































































































































































































































































































































































































































































































































































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import OpenDataComponent from '@/components/openData.vue';
import moment from 'moment';
import { getNumber } from '@/helpers';

@Component({
  components: {
    OpenDataComponent
  }
})
export default class ProjectEditComponent extends Vue {
  project = this.$store.state.project;
  lookup = this.$store.state.lookup;
  account = this.$store.state.account;
  window = 0;
  startedOnOpen = false;
  endedOnOpen = false;
  grantContractSignDateOpen = false;
  documentationArchivedTilOpen = false;
  dialogState = {};
  searchSolver = '';
  isCoordinatorFocused = false;
  requiredRule = [(v: any) => !!v || this.$t('project.error.requiredField')];
  autocompleteSearch = '';
  steps = {
    step1: {
      valid: true
    },
    step2: {
      valid: true
    },
    step3: {
      valid: true
    },
    step4: {
      valid: true
    },
    step5: {
      valid: true
    }
  };

  created() {
    if (this.project.detail.responsibleFaculty) {
      this.$store.dispatch('account/getSolvers', this.project.detail.responsibleFaculty.id);
    }

    this.project.detail.budget.budget = this.project.detail.budget.budget.toLocaleString('cs-CZ');
    this.project.detail.budget.grantAmount = this.project.detail.budget.grantAmount.toLocaleString('cs-CZ');
    this.project.detail.budget.coFinancingPublicSourcesAmount = this.project.detail.budget.coFinancingPublicSourcesAmount.toLocaleString('cs-CZ');
    this.project.detail.budget.shareOfInvestmentCosts = this.project.detail.budget.shareOfInvestmentCosts.toLocaleString('cs-CZ');
  }

  get detail() {
    return this.project.detail;
  }

  getLookup(id: number) {
    const lookup = this.$store.getters['lookup/getAvailableLookupDetail'](id);
    return lookup
      .filter((item: any) => !item.isDisabled)
      .sort((a: any, b: any) => (a.value.normalize('NFD').replace(/[\u0300-\u036f]/g, '') < b.value.normalize('NFD').replace(/[\u0300-\u036f]/g, '') ? -1 : 1));
  }

  get getMainFieldLookup() {
    const lookup = this.$store.getters['lookup/getAvailableLookupDetail'](9);
    return lookup
      .filter((item: any) => !item.isDisabled)
      .filter((i: any) => !(this.project.detail.mainFieldGroup as any).key || (this.project.detail.mainFieldGroup as any).key === i.referenceKey)
      .sort((a: any, b: any) => (a.value.normalize('NFD').replace(/[\u0300-\u036f]/g, '') < b.value.normalize('NFD').replace(/[\u0300-\u036f]/g, '') ? -1 : 1));
  }

  get getGrantProgramLookup() {
    const lookup = this.$store.getters['lookup/getAvailableLookupDetail'](4);
    return lookup
      .filter((item: any) => !item.isDisabled)
      .filter((i: any) => !(this.project.detail.provider as any).key || (this.project.detail.provider as any).key === i.referenceKey)
      .sort((a: any, b: any) => (a.value.normalize('NFD').replace(/[\u0300-\u036f]/g, '') < b.value.normalize('NFD').replace(/[\u0300-\u036f]/g, '') ? -1 : 1));
  }

  getFacultyLookup() {
    return this.account.user.user.role === 'Administrator' || this.isFormDisabled
      ? this.getLookup(6)
      : this.getLookup(6).filter((lookupItem: any) => this.account.user.user.faculties?.find((item: any) => item.facultyId === lookupItem.id));
  }

  get isFormValid() {
    return this.steps.step1.valid && this.steps.step2.valid && this.steps.step3.valid && this.steps.step4.valid && this.steps.step5.valid;
  }

  get visibleState() {
    const state = (this.project.detail.state as any).key;

    return state === '04' || state === '05' || state === '06';
  }

  get visibleNonRequiredFields() {
    const state = (this.project.detail.state as any).key;

    return state !== '08';
  }

  get isGrantContractSignDateVisible() {
    const state = (this.project.detail.state as any).key;

    return state === '03' || state === '04' || state === '05' || state === '06';
  }

  get isSustainable() {
    return (this.project.detail as any).isSustainable;
  }

  get facultyId() {
    return (this.project.detail as any).responsibleFaculty.key;
  }

  get isNonResearchProject() {
    return (this.project.detail as any).isNonResearchProject;
  }

  get mainFieldGroup() {
    return (this.project.detail.mainFieldGroup as any)?.key;
  }

  get provider() {
    return (this.project.detail.provider as any).key;
  }

  get startedOn(): string | null {
    return this.project.detail.startedOn ? moment(this.project.detail.startedOn).format('YYYY-MM-DD') : null;
  }

  set startedOn(date: string | null) {
    this.project.detail.startedOn = date;
  }

  get endedOn(): string | null {
    return this.project.detail.endedOn ? moment(this.project.detail.endedOn).format('YYYY-MM-DD') : null;
  }

  set endedOn(date: string | null) {
    this.project.detail.endedOn = date;
  }

  get grantContractSignDate(): string | null {
    return this.project.detail.grantContractSignDate ? moment(this.project.detail.grantContractSignDate).format('YYYY-MM-DD') : null;
  }

  set grantContractSignDate(date: string | null) {
    this.project.detail.grantContractSignDate = date;
  }

  get documentationArchivedTil(): string | null {
    return this.project.detail.documentationArchivedTil ? moment(this.project.detail.documentationArchivedTil).format('YYYY-MM-DD') : null;
  }

  set documentationArchivedTil(date: string | null) {
    this.project.detail.documentationArchivedTil = date;
  }

  get projectDuration() {
    if (this.endedOn && this.startedOn) {
      const a = moment(this.endedOn);
      const b = moment(this.startedOn);

      const years = a.diff(b, 'year');
      b.add(years, 'years');

      const months = a.diff(b, 'months');
      b.add(months, 'months');

      const days = a.diff(b, 'days');

      return {
        years: years,
        months: months,
        days: days
      };
    } else {
      return {
        years: '-',
        months: '-',
        days: '-'
      };
    }
  }

  get startedOnValidation() {
    return [
      (value: string) => (value !== null && value !== '') || this.$t('project.error.requiredField'),
      (value: string) => !this.endedOn || moment(value) <= moment(this.endedOn) || this.$t('project.error.startedOn')
    ];
  }

  get endedOnValidation() {
    return [
      (value: string) => (value !== null && value !== '') || this.$t('project.error.requiredField'),
      (value: string) => !this.startedOn || moment(value) >= moment(this.startedOn) || this.$t('project.error.endedOn')
    ];
  }

  get budgetValidation() {
    return [(value: string) => (value !== null && value !== '' && getNumber(value) >= 0) || this.$t('project.error.requiredField')];
  }

  get grantAmountValidation() {
    return [
      (value: string) => (value !== null && value !== '' && getNumber(value) >= 0) || this.$t('project.error.requiredField'),
      (value: string) => (getNumber(value) >= 0 && getNumber(value) <= this.budget) || this.$t('project.error.grantAmountValidation')
    ];
  }

  get coFinancingPublicValidation() {
    return [
      (value: string) => (value !== null && value !== '' && getNumber(value) >= 0) || this.$t('project.error.requiredField'),
      (value: string) => getNumber(value) <= Number((this.budget - this.grantAmount).toFixed(2)) || this.$t('project.error.coFinancingPublicValidation')
    ];
  }

  get shareOfInvestmentCostsValidation() {
    return [(value: string) => value !== '' || this.$t('project.error.requiredField'), (value: string) => getNumber(value) <= this.budget || this.$t('project.error.shareOfInvestmentCostsValidation')];
  }

  get availableStatuses(): [] {
    return this.$store.getters['project/getAvailableStatuses']();
  }

  // get availableStatusesOnReguest(): [] {
  //   return this.$store.getters['project/getAvailableOnRequestStatuses']();
  // }

  get isFormDisabled(): boolean {
    const facultyAllowed = this.account.user.user.role === 'Administrator' || this.account.user.user.faculties?.find((item: any) => item.facultyId === this.project.detail.responsibleFaculty.id);

    // return !facultyAllowed || this.project.detail.stateRequests.filter((state: any) => state.approved === undefined).length > 0;
    return !facultyAllowed;
  }

  get canRequestStateChange(): boolean {
    const facultyAllowed = this.account.user.user.role === 'Administrator' || this.account.user.user.faculties?.find((item: any) => item.facultyId === this.project.detail.responsibleFaculty.id);

    return facultyAllowed;
  }

  get budget(): number {
    return getNumber(this.project.detail.budget.budget);
  }

  get grantAmount(): number {
    return getNumber(this.project.detail.budget.grantAmount);
  }

  get coFinancingPublicSourcesAmount(): number {
    return getNumber(this.project.detail.budget.coFinancingPublicSourcesAmount);
  }

  get shareOfInvestmentCosts(): number {
    return getNumber(this.project.detail.budget.shareOfInvestmentCosts);
  }

  getFormatedDate(date: Date) {
    return date ? moment(date).format('DD.MM.YYYY') : '';
  }

  getGrantAmountPercentage() {
    (this.project.detail.budget as any).grantAmountPercentage = Math.round((this.grantAmount / this.budget) * 100);
    return (this.project.detail.budget as any).grantAmountPercentage;
  }

  getCoFinancingPublicSourcesPercentage() {
    const budget = this.project.detail.budget as any;
    budget.coFinancingPublicSourcesPercentage = Math.round((Number(this.coFinancingPublicSourcesAmount || 0) / this.budget) * 100);
    return budget.coFinancingPublicSourcesPercentage;
  }

  getCoFinancingNonPublicSourcesPercentage() {
    const budget = this.project.detail.budget as any;

    budget.coFinancingNonPublicSourcesPercentage = Math.round((Number(budget.coFinancingNonPublicSourcesAmount || 0) / this.budget) * 100);
    return budget.coFinancingNonPublicSourcesPercentage;
  }

  getCoFinancingNonPublicSourcesAmount() {
    const budget = this.project.detail.budget as any;

    budget.coFinancingNonPublicSourcesAmount = Number(this.budget - this.grantAmount - this.coFinancingPublicSourcesAmount).toFixed(2);

    const value = getNumber(budget.coFinancingNonPublicSourcesAmount).toLocaleString('cs-CZ');
    return value;
  }

  getTotalCoFinancing() {
    const budget = this.project.detail.budget as any;
    budget.totalCoFinancing = this.coFinancingPublicSourcesAmount + getNumber(budget.coFinancingNonPublicSourcesAmount);

    const value = getNumber(budget.totalCoFinancing).toLocaleString('cs-CZ');
    return value;
  }

  getShareOfNonInvestmentCosts() {
    const budget = this.project.detail.budget as any;

    budget.shareOfNonInvestmentCosts = Number((this.budget - (this.shareOfInvestmentCosts || 0)).toFixed(2));

    const value = getNumber(budget.shareOfNonInvestmentCosts).toLocaleString('cs-CZ');
    return value;
  }

  remove(item: any) {
    const index = this.project.detail.otherSolvers.indexOf(item.id);
    if (index >= 0) this.project.detail.otherSolvers.splice(index, 1);
  }

  customSolverFilter(item: any, queryText: string, itemText: string) {
    const userName = item.userName.toLowerCase();
    const firstName = item.firstName
      ?.toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');

    const lastName = item.lastName
      ?.toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');

    const searchText = queryText
      .toLowerCase()
      .trim()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');

    return userName.indexOf(searchText) > -1 || firstName?.indexOf(searchText) > -1 || lastName?.indexOf(searchText) > -1;
  }

  async handleUpdateSubmit() {
    if (
      (this.$refs.step1 as any).validate() &&
      (await this.step2Validation()) &&
      (this.$refs.step3 as any).validate() &&
      (this.$refs.step4 as any).validate() &&
      (this.$refs.step5 as any).validate()
    ) {
      const project = this.project.detail;
      project.budget.budget = this.budget;
      project.budget.grantAmount = this.grantAmount;
      project.budget.coFinancingPublicSourcesAmount = this.coFinancingPublicSourcesAmount;
      project.budget.shareOfInvestmentCosts = this.shareOfInvestmentCosts;
      const id = this.$route.params.id;

      this.$store.dispatch('project/updateProject', { id, project });
    }
  }

  async step2Validation() {
    await (this.$refs.step2 as any).validate();
    this.steps.step2.valid = this.project.detail.coordinator !== undefined && this.project.detail.coordinator !== null;

    this.isCoordinatorFocused = true;
    return this.steps.step2.valid;
  }

  sendStateChangeRequest(state: any) {
    const id = this.$route.params.id;
    const stateRequest = { RequestedStateCode: state.key, Note: state.note };
    this.$store.dispatch('project/sendStateChangeRequest', { id, stateRequest });
    this.dialogState = {};
  }

  @Watch('visibleState')
  onStateChanged(value: string, oldValue: string) {
    if (!value) {
      const project = this.project.detail as any;
      project.registrationNumber = '';
      project.contractNumber = '';
    } else {
      this.project.detail.contractNumber = this.project.detail.id.toString();
    }
  }

  @Watch('isSustainable')
  onSustainableChanged(value: string, oldValue: string) {
    if (!value) {
      (this.project.detail as any).sustainabilityDuration = '';
    }
  }

  @Watch('isNonResearchProject')
  onIsNonResearchProject(value: string, oldValue: string) {
    if (!value && oldValue) {
      this.project.detail.mainFieldGroup = { key: '' };
      this.project.detail.mainField = { key: '' };
      this.project.detail.category = { key: '' };
      this.project.detail.secondaryField = { key: '' };
      this.project.detail.otherField = { key: '' };
    }
  }

  @Watch('mainFieldGroup')
  onMainFieldGroupChanged(value: any, oldValue: string) {
    if (oldValue !== '') {
      (this.project.detail.mainField as any).key = '';
    }
  }

  @Watch('provider')
  onProviderChanged(value: any, oldValue: string) {
    if (oldValue !== '') {
      (this.project.detail.grantProgram as any).key = '';
    }
  }

  @Watch('window')
  onStepChanged(value: any, oldValue: any) {
    if (oldValue === 0) {
      (this.$refs.step1 as any).validate();
    }
    if (oldValue === 1) {
      (this.$refs.step2 as any).validate();
    }
    if (oldValue === 2) {
      (this.$refs.step3 as any).validate();
    }
    if (oldValue === 3) {
      (this.$refs.step4 as any).validate();
    }
    if (oldValue === 4) {
      (this.$refs.step5 as any).validate();
    }
  }

  @Watch('facultyId')
  onFacultyChanged(value: any, oldValue: any) {
    if (value && value !== null) {
      const faculty = this.getLookup(6).find((item: any) => item.key === value);

      if (faculty) {
        this.$store.dispatch('account/getSolvers', faculty.id);
      }
    }
  }

  @Watch('budget')
  budgetChanged(value: any) {
    if (value === 0 || value === null) {
      this.project.detail.budget.grantAmount = 0 as any;
      this.project.detail.budget.coFinancingPublicSourcesAmount = 0 as any;
      this.project.detail.budget.shareOfInvestmentCosts = 0 as any;
    }
  }

  // @Watch('searchSolver')
  // onSolverChangeChanged(value: any, oldValue: any) {
  //   if (value && value !== null && value.length > 3) {
  //     this.$store.dispatch('account/getOtherSolvers', value);
  //   }
  // }
}
